export const EXPECTED_RESPONSE_TIME = 24 * 60 * 60;
export const DEADLINE_GREEN_SECS = 3 * 60 * 60;
export const DEADLINE_RED_SECS = 1 * 60 * 60;

export const FILTER_DEBOUNCE = 500;

export const GOOGLE_PLACES_API_KEY = process.env.GOOGLE_PLACES_API_KEY || '';

export const EXTENSION_ORIGIN = `chrome-extension://${process.env.CONNECT_EXTENSION_ID || 'cfmbeleemgicjlggjbddlmckdfllmfch'}`;
